import { render, staticRenderFns } from "./national_english_playerInfo.vue?vue&type=template&id=6fa0c03c&scoped=true"
import script from "./national_english_playerInfo.vue?vue&type=script&lang=js"
export * from "./national_english_playerInfo.vue?vue&type=script&lang=js"
import style0 from "./national_english_playerInfo.vue?vue&type=style&index=0&id=6fa0c03c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0c03c",
  null
  
)

export default component.exports